import { ReassignmentCaseAssignmentCard as LibraryCard } from '@cartwheel/components'
import { useState } from 'react'
import { formatReassignmentDateShort } from '../utils/format-reassignment-date'
import { ReassignmentDetailWrapper } from './reassignment-detail-modal'

/**
 * Props for the ReassignmentCaseAssignmentCard wrapper component.
 * This is an application-level wrapper that handles state and formatting,
 * delegating presentation to the library component.
 */
interface ReassignmentCaseAssignmentCardProps {
  /** Unique identifier for the reassignment (used for modal) */
  reassignmentId: string
  /** Current status of the reassignment (e.g., "assigned_to_cc") */
  status: string
  /** Name of the current clinician, or "None" */
  currentClinician: string
  /** ISO8601 formatted date string for when reassignment takes effect */
  effectiveDate: string
  /** Student availability details */
  studentAvailability: string
}

/**
 * Application-level wrapper for ReassignmentCaseAssignmentCard.
 * Handles modal state and date formatting, delegating presentation to library component.
 */
export default function ReassignmentCaseAssignmentCard({
  reassignmentId,
  status,
  currentClinician,
  effectiveDate,
  studentAvailability,
}: ReassignmentCaseAssignmentCardProps) {
  const [isModalOpen, setIsModalOpen] = useState(false)

  const handleOpenModal = () => {
    setIsModalOpen(true)
  }

  const handleModalClose = () => {
    setIsModalOpen(false)
  }

  const formattedDate = formatReassignmentDateShort(effectiveDate) ?? effectiveDate

  return (
    <>
      <LibraryCard
        status={status}
        currentClinician={currentClinician}
        effectiveDate={formattedDate}
        studentAvailability={studentAvailability}
        onViewDetailsClick={handleOpenModal}
      />
      <ReassignmentDetailWrapper
        reassignmentId={reassignmentId}
        isOpen={isModalOpen}
        onClose={handleModalClose}
        canReview={false}
      />
    </>
  )
}
